import * as React from 'react'
import * as R from 'ramda'
import { RouteComponentProps, withRouter } from 'react-router'
import { compose } from 'react-apollo'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { SocialMediaButtonsSmall } from '../LayoutStyles'
import { BaseButton } from '../../Styled/Shared'
import CommonGreen from './CommonGreen'
import ListContacts from './ListContacts'
import {
  ContactWrapper,
  ColumnWrapper,
  ContactColumn,
  ColumnBody,
  ColumnBlock,
  NormalWeight,
  TinyText,
  MailTo,
  LinkImage,
  Header,
  HeaderLineBold,
  HeaderLine,
  ButtonContainer,
  ColumnHeader
} from './contactStyles'
import { getProjectLocation } from '../../../reducers/project'
import { Store } from '../../../reducers'
import KnownIssues from './KnownIssues'
import styled, { hexToRgba, hexToRgb } from '../../../theme/styled'
import { CountryType, withCountries } from '../../Shared/CountryOptions'

type InputProps = {
  openFeedback: () => void
}

type ContractsProps = {
  projectCountry?: string
  countries: CountryType[]
} & InputProps &
  RouteComponentProps<{}>

type State = {
  country: string
}

const SocialFacebook = require('../LayoutFooter/facebook.svg')
const SocialLinkedIn = require('../LayoutFooter/linkedin.svg')
const SocialYoutube = require('../LayoutFooter/youtube.svg')
const Field = styled.div`
  padding-top: 0.5em;
  margin-right: 1em;

  .errorField {
    border-color: ${({ theme }) => theme.colors.error};
  }
`
const FieldSelect = styled.select`
  font-size: 1rem;
  height: 2em;
  margin-bottom: 0.5em;
  font-weight: bold;
  border-color: ${({ theme }) => theme.colors.invert};
  width: 10em;
  margin-right: 0.5em;
  background: rgba(7, 0, 7, 0.05);
  color: ${({ theme }) => theme.colors.invert};
  border-width: 1px;
  text-overflow: ellipsis;
`
const FieldOption = styled.option`
  background: ${({ theme }) => hexToRgb(theme.colors.brand)};
  background: ${({ theme }) => hexToRgba(theme.colors.brand, '0.95')};
  color: ${({ theme }) => theme.colors.invert};
`

class Contacts extends React.Component<ContractsProps, State> {
  constructor(props: ContractsProps) {
    super(props)
    this.state = { country: this.props.projectCountry || 'fi' }
  }

  selectChanged = (
    event: React.ChangeEvent<HTMLSelectElement>,
    options: CountryType[]
  ) => {
    const found = R.find(opt => opt.id === event.currentTarget.value, options)
    this.setState({
      country: found ? found.id : this.props.projectCountry || 'fi'
    })
    event.preventDefault()
  }

  render() {
    const { countries, openFeedback, history } = this.props

    if (!countries) {
      return null
    }

    return (
      <CommonGreen>
        <ContactWrapper>
          <Header>
            <HeaderLineBold>Do you have a question?</HeaderLineBold>
            <HeaderLine>Let us know &mdash; we're here to help You!</HeaderLine>
          </Header>
          <ColumnWrapper>
            <ContactColumn>
              <ColumnBody>
                <ColumnBlock>
                  <h4 style={{ fontWeight: 700 }}>Select country</h4>
                  <Field>
                    <FieldSelect
                      name={'country'}
                      onChange={e => this.selectChanged(e, countries)}
                      title={'Select country'}
                      value={this.state.country}
                    >
                      <FieldOption disabled={true} value={''}>
                        {' '}
                        -- select --{' '}
                      </FieldOption>
                      {countries.map(option => (
                        <FieldOption key={option.id} value={option.id}>
                          {option.displayName}
                        </FieldOption>
                      ))}
                    </FieldSelect>
                  </Field>
                </ColumnBlock>

                <ColumnBlock>
                  <ColumnHeader>Peikko Group Corporation</ColumnHeader>
                  <TinyText>Tel. + 358 20 707 511</TinyText>
                  <TinyText>
                    <MailTo href="mailto:peikko@peikko.com">
                      peikko@peikko.com
                    </MailTo>
                  </TinyText>
                </ColumnBlock>

                <ColumnBlock>
                  <SocialMediaButtonsSmall>
                    <a
                      href="https://www.facebook.com/peikkogroup/"
                      target="_blank"
                    >
                      <LinkImage src={SocialFacebook} />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/peikko-group/"
                      target="_blank"
                    >
                      <LinkImage src={SocialLinkedIn} />
                    </a>
                    <a
                      href="https://www.youtube.com/user/PeikkoGroupCorp"
                      target="_blank"
                    >
                      <LinkImage src={SocialYoutube} />
                    </a>
                  </SocialMediaButtonsSmall>
                </ColumnBlock>
              </ColumnBody>
            </ContactColumn>

            <ContactColumn>
              <ColumnBody>
                <ListContacts country={this.state.country} />
              </ColumnBody>
            </ContactColumn>

            <ContactColumn>
              <ColumnBody>
                <ColumnHeader>
                  <NormalWeight>Peikko Designer&reg;</NormalWeight> DELTABEAM
                  SELECT
                </ColumnHeader>
                <ColumnHeader>Technical support</ColumnHeader>

                <TinyText>
                  <MailTo href="mailto:peikkodesigner.support@peikko.com">
                    peikkodesigner.support@peikko.com
                  </MailTo>
                </TinyText>
                <ButtonContainer>
                  <BaseButton
                    style={{
                      background: 'rgba(7, 0, 7, .05)',
                      border: '1px solid white',
                      minWidth: '200px',
                      height: '56px',
                      lineHeight: '54px',
                      fontSize: '16px'
                    }}
                    onClick={() => {
                      openFeedback()
                      history.goBack()
                    }}
                  >
                    Give feedback
                  </BaseButton>
                </ButtonContainer>

                <KnownIssues />
              </ColumnBody>
            </ContactColumn>
          </ColumnWrapper>
        </ContactWrapper>
      </CommonGreen>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  projectCountry: getProjectLocation(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({})

export default compose(
  withRouter,
  withCountries,
  connect(mapStateToProps, mapDispatchToProps)
)(Contacts)



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/Contacts.tsx